import React from 'react';
import { PageHero } from '../components/PageHero';
import { EarlyAccess } from '../components/EarlyAccess';
import { FAQ } from '../components/FAQ';
import { SectionStage } from '../components/SectionStage';
export function EarlyAccessPage() {
  return <>
      <PageHero eyebrow="Early Access" title="Be among the first" titleMuted="to validate continuously." description="Tell us about your environment. We'll tailor early access — Snapshot, Team, Business, MSSP, or Enterprise — to where you are right now." bg="none" data-id="element-1494" />
      <SectionStage fx="glow-orbs" data-id="element-1495">
        <EarlyAccess data-id="element-1496" />
      </SectionStage>
      <SectionStage fx="squares" data-id="element-1497">
        <FAQ data-id="element-1498" />
      </SectionStage>
    </>;
}